import { useEffect } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import React from "react";
import { ProfileHoc } from "../../umbilical_hocs";
import { createUseStyles } from "react-jss";
import { Icon } from "@iconify/react";

const styles = createUseStyles({
  ExtTokenAuth: {
    height: "100vh",
    width: "100vw",
    display: "grid",
    placeItems: "center",
  },
  loaderIcon: { fontSize: "xxx-large" },
});
export const ExtTokenAuth = ({ history, guestProfileLoading }) => {
  const classes = styles();

  useEffect(() => {
    if (!guestProfileLoading) {
      history.push("/");
    }
  }, [guestProfileLoading]);

  return (
    <div className={classes.ExtTokenAuth}>
      {guestProfileLoading && (
        <Icon icon="eos-icons:loading" className={classes.loaderIcon} />
      )}
    </div>
  );
};
ExtTokenAuth.propTypes = {
  guestProfileLoading: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
};
export default withRouter(ProfileHoc(ExtTokenAuth, true));
